import Papa from "papaparse";
import React, { useEffect, useRef, useState } from "react";
import { adminReqConfig, api } from "../../include/api";
import "../../styles/Super.css";
import AdminHeader from "./Header";
import { ChevronDown } from "react-feather";
import { useNotification } from "../../Toast/ToastProvider";
import {
  CustomColoredDropdown,
  CustomDropdown,
  formatShortMonthDateYearWithTime,
  getAdmin,
  PAYMENT_OPTIONS,
} from "../../include/function";
import { useNavigate } from "react-router-dom";

const CustomerTransaction = ({ customerId }) => {
  const [fetchLoading, setFetchLoading] = useState(true);
  const [paymentDetailData, setPaymentDetailData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const toast = useNotification();
  const [selectedData, setSelectedData] = useState([]);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const navigate = useNavigate();

  const user = getAdmin();
  const [productPermissions, setProductPermissions] = useState({
    add: false,
    view: false,
    edit: false,
    delete: false,
  });
  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user?.roleId) return;

      try {
        const res = await api.get(
          `/role_permission/?roleId=${user.roleId}`,
          adminReqConfig()
        );
        if (res.status === 200 && Array.isArray(res.data.data)) {
          // Find permission entry where pageTitle === "Product"
          const productPerm = res.data.data.find(
            (p) => p.pageTitle === "Sales Invoices"
          );

          if (productPerm) {
            setProductPermissions({
              add: productPerm.add === "true" || productPerm.add === 1,
              view: productPerm.view === "true" || productPerm.view === 1,
              edit: productPerm.edit === "true" || productPerm.edit === 1,
              delete: productPerm.delete === "true" || productPerm.delete === 1,
            });
          }
        }
      } catch (err) {
        console.warn("Failed to fetch product permissions", err);
      }
    };

    fetchPermissions();
  }, [user?.roleId]);
  //Filter values (all optional)
  const [filterValues, setFilterValues] = useState({
    paymentMethod: "",
    timePeriod: "",
    fromDate: "",
    toDate: "",
  });

  //Fetch orders with filters
  const getPaymentDetails = (filters = {}) => {
    setFetchLoading(true);
    const params = new URLSearchParams();

    // Only add filter params
  if (customerId) {
    params.set("customerId", customerId);
    }
    if (filters.fromDate) params.set("fromDate", filters.fromDate);
    if (filters.toDate) params.set("toDate", filters.toDate);
    if (filters.paymentMethod) params.set("paymentMethod", filters.paymentMethod);
    const url = `/payment/?${params.toString()}`;

    api
      .get(url, adminReqConfig())
      .then((response) => {
        if (response.status === 200 && Array.isArray(response.data.data)) {
          // Sort by date in descending order (newest first)
          const sortedData = response.data.data.sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            return dateB - dateA; 
          });


          setPaymentDetailData(sortedData);
          setFilteredData(sortedData);
        } else {
          setPaymentDetailData([]);
          setFilteredData([]);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch invoice:", error);
        setPaymentDetailData([]);
        setFilteredData([]);
      })
      .finally(() => setFetchLoading(false));
  };

  //Initial load
  useEffect(() => {
    getPaymentDetails();
  }, []);

  //Search
  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredData(paymentDetailData); 
    } else {
      const filtered = paymentDetailData.filter((payment) =>
        payment.paymentMode?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
      setCurrentPage(1);
    }
  }, [searchQuery, paymentDetailData]);

  //Pagination logic
  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;
  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //Close filter panel on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isFilterPanelOpen && !e.target.closest(".nav-item")) {
        setIsFilterPanelOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isFilterPanelOpen]);

  //Export handlers (CSV)
  const handleDownloadCSV = () => {
    const dataToExport =
      selectedData.length > 0
        ? paymentDetailData.filter((payment) =>
            selectedData.includes(payment.id)
          )
        : paymentDetailData;
 
    if (dataToExport.length === 0) {
      toast({ type: "error", message: "No payment data to download" });
      return;
    }
 
    const csvRows = dataToExport.map((payment, index) => {
      const amount = parseFloat(payment.amount) || 0;
 
      return {
        "S.No": index + 1,
        "Payment ID": payment.id || "-",
        "Order ID": payment.orderId || "-",
        "Customer Type": payment.customerType || "-",
        "Payment Date": payment.createdTimestamp
          ? new Date(payment.createdTimestamp).toLocaleString("en-IN")
          : "-",
        "Payment Mode": payment.paymentMode || "-",
        "Payment Status": payment.paymentStatus || "-",
        "Amount": amount.toLocaleString("en-IN"),
        Notes: payment.notes || "-",
 
      
 
 
      };
    });
 
    const columns = [
      "S.No",
      "Payment ID",
      "Order ID",
      "Customer Type",
      "Payment Date",
      "Payment Mode",
      "Payment Status",
      "Amount",
      "Notes",
  
    ];
 
    const csv = Papa.unparse({
      fields: columns,
      data: csvRows,
    });
 
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Transaction_history.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  

  //Selection handlers
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = currentItems.map((p) => p.id);
      setSelectedData((prev) => [...new Set([...prev, ...allIds])]);
    } else {
      const idsToRemove = currentItems.map((p) => p.id);
      setSelectedData((prev) => prev.filter((id) => !idsToRemove.includes(id)));
    }
  };
  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  //Apply & Clear filters
  const applyFilters = () => {
    let finalFilters = { ...filterValues };

    // Handle timePeriod presets
    if (filterValues.timePeriod && filterValues.timePeriod !== "period") {
      const now = new Date();
      let fromDate = "";
      let toDate = "";

      switch (filterValues.timePeriod) {
        case "today":
          fromDate = toDate = now.toISOString().split("T")[0];
          break;
        case "yesterday":
          const yesterday = new Date(now);
          yesterday.setDate(now.getDate() - 1);
          fromDate = toDate = yesterday.toISOString().split("T")[0];
          break;
        case "thisMonth":
          fromDate = `${now.getFullYear()}-${String(
            now.getMonth() + 1
          ).padStart(2, "0")}-01`;
          toDate = now.toISOString().split("T")[0];
          break;
        case "last3Months":
          const threeMonthsAgo = new Date(now);
          threeMonthsAgo.setMonth(now.getMonth() - 3);
          fromDate = threeMonthsAgo.toISOString().split("T")[0];
          toDate = now.toISOString().split("T")[0];
          break;
        case "thisYear":
          fromDate = `${now.getFullYear()}-01-01`;
          toDate = `${now.getFullYear()}-12-31`;
          break;
        case "all":
        default:
          fromDate = toDate = "";
      }

      finalFilters = {
        ...finalFilters,
        fromDate,
        toDate,
      };
    }

    if (finalFilters.timePeriod) {
      finalFilters.date = ""; 
    }

    getPaymentDetails(finalFilters);
    setIsFilterPanelOpen(false);
  };

  const clearFilters = () => {
    const empty = {
      date: "",
      status: "",
      paymentMethod: "",
      customerType: "",
      timePeriod: "",
    };
    setFilterValues(empty);
    getPaymentDetails(empty);
    setIsFilterPanelOpen(false);
  };

  const formatTransactionId = ( payment) => {
    if (!payment?.createdTimestamp || !payment?.id) return "TRN--";

    // Year YY
    const year = new Date(payment.createdTimestamp).getFullYear();
    const yy = String(year).slice(-2);

    // Order Id padded
    const paddedOrderId = String(payment.orderId).padStart(4, "0");

    // Payment transaction ID padded
    const paddedTrnId = String(payment.id).padStart(4, "0");

    return `TRN${yy}/INV${yy}-${paddedOrderId}-${paddedTrnId}`;
  };

  return (
    <>
      <div className="content-wrappr p-0">
        <section
          style={{
            backgroundColor: "#F1F4F9",
            // padding: "30px",
            // marginBottom: "40px",
            minHeight: "80vh",
          }}
        >
          {fetchLoading ? (
            <p>Loading...</p>
          ) : (
            <>
              <div className="rounded-5 bg-white py-24">
                <div className="row align-items-center px-24 py-10 mb-3">
                  <div className="col-md-2">
                    <h6 className="fs-6 mb-0">Payment History</h6>
                  </div>
                  <div className="col-md-7">
                    <div className="d-flex align-items-center">
                      <div
                        className="nav-item w-100"
                        style={{ position: "relative" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #c6d6f5",
                            borderRadius: "8px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <img
                            src="/assets/images/search-icon.png"
                            style={{ width: "18px", marginLeft: "8px" }}
                          />
                          <input
                            type="text"
                            placeholder="Filter and search here..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                              border: "none",
                              outline: "none",
                              padding: "8px",
                              width: "100%",
                              fontSize: "14px",
                              backgroundColor: "transparent",
                            }}
                            onClick={() => {
                              setIsFilterPanelOpen(!isFilterPanelOpen);
                            }}
                          />
                          <ChevronDown
                            size={16}
                            style={{
                              marginRight: "8px",
                              cursor: "pointer",
                              transform: isFilterPanelOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "0.2s",
                            }}
                            onClick={() => {
                              setIsFilterPanelOpen(!isFilterPanelOpen);
                            }}
                          />
                        </div>

                        {isFilterPanelOpen && (
                          <FilterPanel
                            filterValues={filterValues}
                            onFilterChange={(key, value) =>
                              setFilterValues((prev) => ({
                                ...prev,
                                [key]: value,
                              }))
                            }
                            onApply={applyFilters}
                            onClear={clearFilters}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 text-end">
                    <CustomDropdown handleDownloadCSV={handleDownloadCSV} />
                  </div>
                </div>

                {/* Table */}
                <div className="table-responsive mt-24 product-table">
                  <table className="table table-striped custom-striped-table-product-list align-middle">
                    <thead>
                      <tr>
                        <th scope="col">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ borderColor: "#c5d5f5" }}
                            onChange={handleSelectAll}
                            checked={
                              currentItems.length > 0 &&
                              currentItems.every((p) =>
                                selectedData.includes(p.id)
                              )
                            }
                          />
                        </th>

                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Transaction ID
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Payment Method
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Date & time
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Reference.No
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Amt.Recieved
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((payment) => {
                          return (
                            <React.Fragment key={payment.id}>
                              <tr>
                                <td>
                                  <input
                                    type="checkbox"
                                    style={{ borderColor: "#c5d5f5" }}
                                    className="form-check-input"
                                    checked={selectedData.includes(payment.id)} 
                                    onChange={() => handleSelectOne(payment.id)}
                                  />
                                </td>

                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      textWrap: "nowrap",
                                    }}
                                  ></div>
                                  {formatTransactionId(payment)}
                                </td>
                                <td>{payment.paymentMode}</td>
                                <td>
                                  {formatShortMonthDateYearWithTime(
                                    payment.createdTimestamp
                                  )}
                                </td>
                                <td>{payment.refNo || "N/A"}</td>
                                <td>
                                  <CustomColoredDropdown
                                    value={payment.paymentStatus}
                                    options={PAYMENT_OPTIONS}
                                    type="payment"
                                    disable={true}
                                  />
                                </td>
                                <td>{payment.amount}</td>
                              </tr>
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="11" className="text-center py-3">
                            No Transaction found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                  <div className="d-flex align-items-center">
                    <select
                      className="form-select d-inline-block w-auto"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const val = e.target.value;
                        setItemsPerPage(val === "all" ? "all" : parseInt(val));
                        setCurrentPage(1);
                      }}
                      style={{
                        height: "34px",
                        fontSize: "14px",
                        minWidth: "70px",
                      }}
                    >
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="all">All</option>
                    </select>
                    <span className="ms-2">
                      Showing {showingFrom} to {showingTo} of{" "}
                      {filteredData.length} orders
                    </span>
                  </div>
                  <nav>
                    <ul className="pagination mt-0">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          &laquo;
                        </button>
                      </li>
                      {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(
                          1,
                          currentPage - Math.floor(pagesToShow / 2)
                        );
                        let endPage = startPage + pagesToShow - 1;
                        if (endPage > totalPage) {
                          endPage = totalPage;
                          startPage = Math.max(1, endPage - pagesToShow + 1);
                        }
                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                          pageNumbers.push(i);
                        }
                        return pageNumbers.map((pageNum) => (
                          <li
                            key={pageNum}
                            className={`page-item ${
                              currentPage === pageNum ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => paginate(pageNum)}
                            >
                              {pageNum}
                            </button>
                          </li>
                        ));
                      })()}
                      <li
                        className={`page-item ${
                          currentPage === totalPage ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          &raquo;
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </>
          )}
        </section>
      </div>
    </>
  );
};

export default CustomerTransaction;

//Filter Panel Component
const FilterPanel = ({
  filterValues,
  onFilterChange,
  onApply,
  onClear,

}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "500px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        padding: "16px",
        maxHeight: "500px",
        overflowY: "auto",
        marginTop: "10px",
      }}
    >
      <div className="row g-3">
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.timePeriod}
            onChange={(e) => onFilterChange("timePeriod", e.target.value)}
          >
            <option value="">Time Period</option>
            <option value="all">All Time</option>
            <option value="today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="thisMonth">This Month</option>
            <option value="last3Months">Last 3 Months</option>
            <option value="thisYear">This Year</option>
            <option value="period"> Period</option>
          </select>
        </div>

        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.paymentMethod}
            onChange={(e) => onFilterChange("paymentMethod", e.target.value)}
          >
            <option value="">Payment Type</option>
            <option value="cash">Cash</option>
            <option value="cheque">Cheque</option>
            <option value="credit-card">Credit Card</option>
            <option value="debit-card">Debit Card</option>
            <option value="net-banking">Net Banking</option>
            <option value="upi">UPI</option>
            <option value="neft">NEFT</option>
            <option value="rtgs">RTGS</option>
          </select>
        </div>

        {/* Conditional: Show fromDate & toDate only when "period" is selected */}
        {filterValues.timePeriod === "period" && (
          <>
            <div className="col-md-6">
              <input
                type={filterValues.fromDate ? "date" : "text"}
                className="form-control filter-input"
                placeholder="From Date"
                value={filterValues.fromDate}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                  if (!filterValues.fromDate) e.target.type = "text";
                }}
                onChange={(e) => onFilterChange("fromDate", e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <input
                type={filterValues.toDate ? "date" : "text"}
                className="form-control filter-input"
                placeholder="To Date"
                value={filterValues.toDate}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                  if (!filterValues.toDate) e.target.type = "text";
                }}
                onChange={(e) => onFilterChange("toDate", e.target.value)}
              />
            </div>
          </>
        )}
      </div>
      <div className="d-flex gap-14 mt-24">
        <button
          onClick={onApply}
          style={{
            color: "#fff",
            backgroundColor: "#2b95d3",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
          }}
        >
          Apply Filters
        </button>
        <button
          onClick={onClear}
          style={{
            color: "#2692d2",
            backgroundColor: "#d9ebff",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
            gap: "6px",
          }}
        >
          Clear All
        </button>
      </div>
    </div>
  );
};

